module.exports = __webpack_public_path__ + "/img/Crystal-m3nq9e.svg";